import { format, parseISO } from 'date-fns';

const NUMBER = 12;

export const getTodayDate = (): string => new Date().toISOString();

export const getNewDate = (date?: string): Date =>
  date ? new Date(date) : new Date();

export const toISOShortString = (date: string): string =>
  format(parseISO(date), 'yyyy-MM-dd');

export const toUSLocaleShortString = (
  date?: string,
  shortYear?: boolean,
): string => {
  const dateObj = date ? new Date(date) : new Date();

  const formattedDate = dateObj.toLocaleDateString('en-US', {
    year: shortYear ? '2-digit' : 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC',
  });

  return formattedDate;
};

export const toISOString = (date: Date): string => date.toISOString();

export const convertTo24HourFormat = (time: string): string => {
  const [timeOption, period] = time.split(' ');
  const [hours, minutes] = timeOption.split(':');

  let newHours = Number(hours);

  if (period === 'PM' && newHours !== NUMBER) {
    newHours += NUMBER;
  } else if (period === 'AM' && newHours === NUMBER) {
    newHours = 0;
  }

  const formattedHours = String(newHours).padStart(2, '0');
  return `${formattedHours}:${minutes}`;
};

export const convertTo12HourFormat = (time: string): string => {
  const [hours, minutes] = time.split(':');
  const hour = Number(hours);
  const period = hour < NUMBER ? 'AM' : 'PM';
  const newHours = hour % NUMBER || NUMBER;
  const formattedHours = String(newHours).padStart(2, '0');

  return `${formattedHours}:${minutes} ${period}`;
};

export const dateToFullUTCFormat = (date: string): string =>
  format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");

export const dateToWeekDay = (date: string): string =>
  format(date, 'eeee').toLowerCase();

export const dateToReadableFormat = (
  date: string | undefined,
): string | undefined =>
  date ? format(parseISO(date), 'MMMM do yyyy') : undefined;

export const formatDateRangeReadable = (
  startDate: string,
  endDate: string,
): string => {
  const start = parseISO(startDate);
  const end = parseISO(endDate);

  const startMonth = format(start, 'MMM');
  const endMonth = format(end, 'MMM');
  const startDay = format(start, 'd');
  const endDay = format(end, 'd');
  const year = format(end, 'yyyy');

  if (startMonth === endMonth) {
    return `${startMonth} ${startDay} – ${endDay}, ${year}`;
  }

  return `${startMonth} ${startDay} – ${endMonth} ${endDay}, ${year}`;
};
